import { Trans } from '@lingui/macro'
import { type Model } from 'jms-domain'

import { AttributeToggleSelector } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

interface HandingControlProps {
  id: Model.AdjustableDoorCabinet['id'] | Model.BottomAdjustableDoorAppliance['id']
}

export const HandingControl = (props: HandingControlProps) => {
  const { id } = props

  return (
    <PropertyContainer.Item title={<Trans>Hinge orientation</Trans>}>
      <AttributeToggleSelector entityId={id} instanceName="handing" />
    </PropertyContainer.Item>
  )
}
